import "./EdgeProtection.module.css";
import Header from "@/reusable_sections/Header";
import Edgeprotection from "./sections/Edgeprotection";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function EdgeProtectionPage() {
  return <div>
      <Header />
      <Edgeprotection />
      <RelatedServices />
      <Footer />
    </div>;
}